import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  username: "",
  token: "",
};

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState,
  reducers: {
    setResetData: (state, action) => {
      state.username = action.payload.username;
      state.token = action.payload.token;
    },
    clearResetData: (state) => {
      state.username = "";
      state.token = "";
    },
  },
});

export const { setResetData, clearResetData } = resetPasswordSlice.actions;
export const selectResetData = (state) => state.resetPassword;

export default resetPasswordSlice.reducer;